import { render } from "./DescuentosNew.vue?vue&type=template&id=3d3e777d&scoped=true"
import script from "./DescuentosNew.vue?vue&type=script&lang=js"
export * from "./DescuentosNew.vue?vue&type=script&lang=js"

import "./DescuentosNew.vue?vue&type=style&index=0&id=3d3e777d&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3e777d"]])

export default __exports__